import { render, staticRenderFns } from "./reportsList.vue?vue&type=template&id=08e393b1&scoped=true&"
import script from "./reportsList.vue?vue&type=script&lang=js&"
export * from "./reportsList.vue?vue&type=script&lang=js&"
import style0 from "./reportsList.vue?vue&type=style&index=0&id=08e393b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e393b1",
  null
  
)

export default component.exports